import { ENVIRONMENT } from '../../../../environment';

const FACEBOOK_KEY = ENVIRONMENT.keys.facebook;
const FACEBOOK_ENDPOINT = ENVIRONMENT.endpoints.facebook;

export function loadFacebook() {
  window.fbAsyncInit = () => {
    FB.init({
      appId: FACEBOOK_KEY,
      version: 'v2.10',
    });
  };

  // https://developers.facebook.com/docs/javascript/quickstart
  (function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = FACEBOOK_ENDPOINT;
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}

export function shareOnFacebook(link, callback) {
  FB.ui(
    {
      link,
      method: 'feed',
    },
    callback
  );
}
